import { render, staticRenderFns } from "./LatexNumber.vue?vue&type=template&id=924836f4&"
import script from "./LatexNumber.vue?vue&type=script&lang=js&"
export * from "./LatexNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports